import { Injectable } from '@angular/core';

import { GoogleObj } from 'src/app/Models/Googletranslate';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from '../Services/config/http-error-handler.service';
import {BaseSvcService} from '../Services/config/base-svc.service';
import { AppOfflineStore } from '../app.offlineService';

//import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class GoogletranslateService {
  public url:string = 'https://translation.googleapis.com/language/translate/v2?key=';
  //public url:string = 'https://translation.googleapis.com/language/translate/v2'; 
  key = 'AIzaSyCtQRD0lQRyCntbKvBv6XchsMOy0kjsxI4';
  private handleError: HandleError;
 
  public options;
  constructor(private http: HttpClient,
    private appserv:AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config:BaseSvcService) {
      this.handleError = httpErrorHandler.createHandleError('HeroesService');
    //this.url=this.config.activeURL;
    this.options=this.config._httpoption;
     }
  translate(obj: GoogleObj) {
    if(this.appserv.userlanuage){
    obj.target=this.appserv.MotherTongueLanguage;
   }
   return this.http
   .post<any>(this.url+this.key,obj,this.options)
   .pipe(
         
     catchError(this.handleError('getQuestion', []))
   );
   
  //   return this.http.post(this.url + this.key, obj);
  // }
   }
}
